'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Switch = exports.Radio = exports.Checkbox = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noop = function noop() {};

var typeAliases = {
  switch: 'checkbox'
};

var Control = function Control(_ref) {
  var _classnames;

  var _ref$type = _ref.type,
      type = _ref$type === undefined ? 'checkbox' : _ref$type,
      className = _ref.className,
      size = _ref.size,
      disabled = _ref.disabled,
      name = _ref.name,
      _ref$value = _ref.value,
      value = _ref$value === undefined ? false : _ref$value,
      readOnly = _ref.readOnly,
      inline = _ref.inline,
      color = _ref.color,
      children = _ref.children,
      label = _ref.label,
      reversed = _ref.reversed,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === undefined ? noop : _ref$onChange;
  return _react2.default.createElement(
    'label',
    {
      className: (0, _classnames3.default)('control', className, type, (_classnames = {}, (0, _defineProperty3.default)(_classnames, 'control-' + (_constants.sizeAliases[size] || size), size), (0, _defineProperty3.default)(_classnames, 'control-inline', inline), (0, _defineProperty3.default)(_classnames, 'control-reversed', reversed), (0, _defineProperty3.default)(_classnames, color, _constants.indicatorMap[color]), _classnames)) },
    _react2.default.createElement('input', {
      name: name,
      type: typeAliases[type] || type,
      disabled: disabled || readOnly,
      checked: value,
      onClick: function onClick(event) {
        return onChange(event.target.checked);
      },
      onChange: noop
    }),
    _react2.default.createElement('span', { className: 'control-indicator' }),
    (children || label) && _react2.default.createElement(
      'span',
      { className: 'control-label' },
      children || label
    )
  );
};

var Checkbox = exports.Checkbox = Control;
var Radio = exports.Radio = function Radio(props) {
  return _react2.default.createElement(Control, (0, _extends3.default)({}, props, { type: 'radio' }));
};
var Switch = exports.Switch = function Switch(props) {
  return _react2.default.createElement(Control, (0, _extends3.default)({}, props, { type: 'switch' }));
};

exports.default = Control;